import * as React from "react";
import Svg, { Circle, G, Path, Defs, ClipPath, Rect } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const SVGComponent = (props) => (
  <Svg
    width={props.size || 36}
    height={props.size || 36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Circle cx={18} cy={18} r={18} fill={props.bgColor || "#E7F4ED"} />
    <G clipPath="url(#clip0_9022_8914)">
      <G filter="url(#filter0_d_9022_8914)">
        <Path
          d="M22.0408 13.7083L23.2408 14.9083L19.1741 18.975L16.4324 16.2333C16.1074 15.9083 15.5824 15.9083 15.2574 16.2333L10.2574 21.2417C9.93242 21.5667 9.93242 22.0917 10.2574 22.4167C10.5824 22.7417 11.1074 22.7417 11.4324 22.4167L15.8408 18L18.5824 20.7417C18.9074 21.0667 19.4324 21.0667 19.7574 20.7417L24.4158 16.0917L25.6158 17.2917C25.8741 17.55 26.3241 17.3667 26.3241 17V13.4167C26.3324 13.1833 26.1491 13 25.9158 13H22.3408C21.9658 13 21.7824 13.45 22.0408 13.7083Z"
          fill={props.color || "#109648"}
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="clip0_9022_8914">
        <Rect width={20} height={20} fill="white" transform="translate(8 8)" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
